/** src/services/auth.api.ts 의 짝. */
import { HttpResponse, http } from "msw";
import { db } from "../db";
import { MOCK_PASSWORD } from "../data/staff";
import { fail, latency, requireUser } from "../http";

export const authHandlers = [
  http.get("/api/v1/me/", async () => {
    await latency();
    const user = requireUser();
    return user instanceof Response ? user : HttpResponse.json(user);
  }),

  http.post("/accounts/login/", async ({ request }) => {
    await latency();
    const { email, password } = (await request.json()) as { email?: string; password?: string };
    if (!email || !password) return fail(422, "이메일과 비밀번호를 입력하세요.");

    const user = db.users.find((u) => u.email === email);
    if (!user || password !== (db.passwords[user.id] ?? MOCK_PASSWORD)) {
      return fail(401, "이메일 또는 비밀번호가 올바르지 않습니다.");
    }
    db.signIn(user.id);
    return new HttpResponse(null, { status: 204 });
  }),

  http.post("/api/v1/me/password/", async ({ request }) => {
    await latency();
    const user = requireUser();
    if (user instanceof Response) return user;
    const { current_password, new_password } = (await request.json()) as {
      current_password?: string;
      new_password?: string;
    };
    if (db.users.find((row) => row.id === user.id)?.created_via_google)
      return fail(
        409,
        "Google 로 처음 만들어진 계정이라 비밀번호를 정할 수 없습니다. Google 로 로그인하세요."
      );
    // 비밀번호가 없는 사람은 바꿀 것이 없다 — 서버와 같다.
    if (!db.users.find((row) => row.id === user.id)?.has_password)
      return fail(
        409,
        "비밀번호로 로그인하는 계정이 아닙니다. 관리자에게 비밀번호 설정을 요청하세요."
      );
    if (current_password !== (db.passwords[user.id] ?? MOCK_PASSWORD))
      return fail(400, "현재 비밀번호가 맞지 않아요.");
    // 백엔드 app/accounts/passwords.py 의 규칙과 같다.
    if (!new_password || new_password.length < 10)
      return fail(422, "비밀번호는 10자 이상이어야 합니다.");
    if (new_password.length > 128) return fail(422, "비밀번호는 128자 이하여야 합니다.");
    db.passwords[user.id] = new_password;
    return new HttpResponse(null, { status: 204 });
  }),

  http.get("/api/v1/site/", async () => {
    await latency();
    return HttpResponse.json(db.site);
  }),
];
